import { render, staticRenderFns } from "./SendResearch.vue?vue&type=template&id=00bc74c3&"
import script from "./SendResearch.vue?vue&type=script&lang=js&"
export * from "./SendResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports